module.exports = __webpack_public_path__ + "img/sunmiPrinter.4685a1f3.jpeg";